"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://stackoverflow.com/a/29246176
function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
exports.default = randomInteger;
